import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const SearchInput = ({
  value,
  onChange,
  placeholder = "Filter results...",
  className = "",
  id = "search",
  ...props
}) => {
  return (
    <div className={`search-input-wrapper ${className}`}>
      <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
      <input
        id={id}
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="search-input"
        {...props}
      />
    </div>
  );
};

export default SearchInput;
